import React from 'react';
import styled from 'styled-components';

import { LanguagePicker } from '../language-picker';
import {
  Container,
  LeftContent,
  ContentContainer,
  RightBackground,
  CNXLogo,
} from './split-view.style';
import { SplitViewProps } from './split-view.type';

const LogoHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SplitView = ({ title, children }: SplitViewProps): JSX.Element => {
  return (
    <Container>
      <LeftContent>
        <ContentContainer>
          <LogoHeader>
            <CNXLogo />
            <LanguagePicker />
          </LogoHeader>
          {title && <h2>{title}</h2>}
          {children}
        </ContentContainer>
      </LeftContent>
      <RightBackground />
    </Container>
  );
};

export { SplitView };
